import { render, staticRenderFns } from "./MarkupTableCell.vue?vue&type=template&id=ce85aa60"
import script from "./MarkupTableCell.vue?vue&type=script&lang=js"
export * from "./MarkupTableCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports